<div class="map">
    <iframe
    width="100%"
    height="100%"
    frameborder="0" style="border:0;border-radius: 10px;z-index: 1100;"
    src="https://www.google.com/maps/embed/v1/place?key=AIzaSyD6JumlPFLkyQHY2TGrGOnebR48Wk4Iw3w
      &q=MAHARANA PRATAP PUBLIC SCHOOL, Kurukshetra, HAryana, 136118" allowfullscreen>
  </iframe>
</div>